import * as React from "react";

const Zakia = () => {
  return (
    <ol className="references">
     <li>
      Centers for Disease Control and Prevention. HIV in the southern United States. Published September 2019. Accessed February 2, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf">https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf</a>
      </li>
      <li>
      Berkowitz SA, Basu S, Gundersen C, Seligman HK. State-level and county-level estimates of health care costs associated with food insecurity. <i>Prev Chronic Dis.</i> 2019;16:E90.
      </li>          
      <li>
      Centers for Disease Control and Prevention. Estimated HIV incidence and prevalence in the United States, 2015–2019. HIV Surveillance Supplemental Report. 2021;26(1). Published May 2021. Accessed February 2, 2022.&nbsp;
      <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf">https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf</a>
      </li>
      <li>
      Myers JE, Braunstein SL, Xia Q, et al. Redefining prevention and care: a status-neutral approach to HIV. <i>Open Forum Infect Dis.</i> 2018;5(6):ofy097.
      </li>
      <li>
      Kimmel AD, Masiano SP, Bono RS, et al. Structural barriers to comprehensive, coordinated HIV care: geographic accessibility in the US South. <i>AIDS Care</i>. 2018;30(11):1459-1468.
      </li>
      <li>
      Wise JM, Ott C, Azuero A, et al. Barriers to HIV testing: patient and provider perspectives in the deep south. <i>AIDS Behav</i>. 2019;23(4):1062-1072.
      </li>
      <li>
      Pellowski JA. Barriers to care for rural people living with HIV: a review of domestic research and health care models. <i>J Assoc Nurses AIDS Care</i>. 2013;24(5):422-437.
      </li>
      <li>
      US Census Bureau. 2019 American community survey 1-year estimates: selected characteristics of the uninsured in the United States. Accessed February 4, 2022.&nbsp;
      <a target="_blank" className="" href="https://data.census.gov/cedsci/table?q=S2702%3A%20SELECTED%20CHARACTERISTICS%20OF%20THE%20UNINSURED%20IN%20THE%20UNITED%20STATES&t=Health%20Insurance&g=0200000US1,2,3,4&y=2019&tid=ACSST1Y2019.S2702&tp=true">https://data.census.gov/cedsci/table?q=S2702%3A%20SELECTED%20CHARACTERISTICS%20OF%20THE%20UNINSURED%20IN%20THE%20UNITED%20STATES&t=Health%20Insurance&g=0200000US1,2,3,4&y=2019&tid=ACSST1Y2019.S2702&tp=true</a>
      </li>
      <li>
      US Census Bureau. Who are the uninsured? Most uninsured were working-age adults. Accessed September 12, 2018.&nbsp;
      <a target="_blank" className="" href="https://www.census.gov/library/stories/2018/09/who-are-the-uninsured.html">https://www.census.gov/library/stories/2018/09/who-are-the-uninsured.html</a>
      </li>
      <li>
      Reif S, Safley D, McAllaster C, Wilson E, Whetten K. State of HIV in the US deep south. <i>J Community Health</i>. 2017;42(5):844-853.
      </li>
      <li>
      Henkhaus ME, Hussen SA, Brown DN, et al. Barriers and facilitators to use of a mobile HIV care model to re-engage and retain out-of-care people living with HIV in Atlanta, Georgia. <i>PLoS One</i>. 2021;16(3):e0247328.
      </li>
      <li>
      Centers for Disease Control and Prevention. Understanding the HIV care continuum. July 2019. Accessed July 30, 2021.&nbsp;
      <a target="_blank" className="" href="https://www.cdc.gov/hiv/pdf/library/factsheets/cdc-hiv-care-continuum.pdf">https://www.cdc.gov/hiv/pdf/library/factsheets/cdc-hiv-care-continuum.pdf</a>
      </li>
    </ol>
  )
  }

export default Zakia;
